import { StaticVideo } from '@/types/video.types';
import { Post } from '../helpers';

export const saveVideo = (video: StaticVideo): Promise<StaticVideo> => {
  return Post({
    path: `/v4/videos/channel/${video.channel}/video`,
    body: video,
  });
};
